// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link":"_1TvqYu","mobileLink":"KOJoFb","categoryCard":"_1kwy-E","section":"_3aNG9-","category":"_1gKzOw","iconHolder":"_1x3hBz"};